'use client';
import { useEffect } from 'react';

export default function ServiceWorkerRegistration() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      // First unregister any stale service workers, then register fresh
      navigator.serviceWorker?.getRegistrations()?.then((registrations) => {
        const unregisterAll = registrations?.map((reg) => reg?.unregister());
        return Promise.all(unregisterAll);
      })?.then(() => {
        // Re-register the updated service worker
        return navigator.serviceWorker?.register('/sw.js');
      })?.catch(() => {
        // Service worker registration failed silently
      });
    }
  }, []);

  return null;
}
